// A1 mark (brand.json logo_paths). Inline so its colour follows the theme:
// the brand green on dark, a deeper green on the light theme for contrast.
export default function Logo({ size = 30, className = "" }: { size?: number; className?: string }) {
  return (
    <svg
      className={`a1-logo ${className}`.trim()}
      width={size}
      height={Math.round(size * 0.86)}
      viewBox="0 0 100 86"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M0 86 51 0 62 19 23 86Z" />
      <path d="M58 48 69 29 100 86 77 86Z" />
    </svg>
  );
}
